import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { generateRedirectUrl } from "../../api/idServer";
import { optionsAdminAuth } from "../../api/adminAuthMode";
import { loginUrl } from "../../utils/returnUrl";
import Loader from "../../shared/Loader";

export const RedirectLogin = () => {
  const location = useLocation();
  useEffect(() => {
    if (!optionsAdminAuth) window.location.replace(generateRedirectUrl());
  }, []);

  if (optionsAdminAuth) {
    return (
      <Navigate
        to={loginUrl(`${location.pathname}${location.search}${location.hash}`)}
        replace
      />
    );
  }
  return <Loader />;
};
